import * as React from "react";
import { BranchPromotionSlideModel, IBranchModel } from "states/branch/branch.models";
import { ModalComponent } from "shared/components/modal/modal";
import { useEffect, useState } from "react";
import { getBranchPromotionSlideAPI } from "states/branch/branch.api";
import Slider from "react-slick";
import { isDesktop } from "react-device-detect";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./promotion-slide-modal.less";
interface IPromotionSlideModalProps {
  currentBranch: IBranchModel;
}
interface PromotionSlideModal {
  open: boolean;
  onClose: () => void;
  slideBanners: BranchPromotionSlideModel[];
}
export function PromotionSlideModal({ currentBranch }: IPromotionSlideModalProps) {
  const [promotionModal, setPromotionModal] = useState<PromotionSlideModal>({
    open: false,
    onClose: () => {
      setPromotionModal({ ...promotionModal, open: false })
    },
    slideBanners: [],
  } as PromotionSlideModal);
  const handleGetPromotionSlide = async () => {
    try {
      if (currentBranch?.id) {
        let results = await getBranchPromotionSlideAPI(currentBranch?.id);
        if (results.data.length > 0) {
          setPromotionModal({ ...promotionModal, open: true, slideBanners: results.data.sort((a, b) => a.sort - b.sort) })
        }
      }
    } catch (error) {

    }
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  useEffect(() => {
    handleGetPromotionSlide();
  }, [currentBranch])
  return <>
    <ModalComponent
      portalClassName={`ModalSlidePromotion`}
      width={`${!isDesktop ? `100%`:`800px`}`}
      height={`auto`}
      className="w-full bg-white rounded-2xl"
      isCustomizeFooter={true}
      isModal={true}
      onCloseModal={promotionModal?.onClose}
      isOpenModal={promotionModal?.open}
      title={` `}
    >
      {promotionModal?.slideBanners && (
        <div className="p-3">
          {!isDesktop ? (
            <Slider {...settings}>
              {promotionModal?.slideBanners?.map(src => (
                <div>
                  <a href={src.url}>
                    <img src={src.mobileSrc} alt={src.mobileSrc} />
                  </a>
                </div>
              ))}
            </Slider>
          ) : (
            <Slider {...settings}>
              {promotionModal?.slideBanners?.map(src => (
                <div>
                  <a href={src.url}>
                    <img src={src.src} alt={src.src} />
                  </a>
                </div>
              ))}
            </Slider>

          )}
        </div>
      )}
    </ModalComponent>
  </>;
}
